import api from "../../api/cofocusAPI";

const CalendarAPI = {
  async getUserBookingData(UID) {
    if (!UID) {
      throw new Error("Required data not provided for request.");
    }
    return await api.getResponseData({
      url: `api/upcomingsessions/${UID}/bookingData`,
      method: "get",
      withCredentials: true,
    });
  },

  async getNrOfUsedFreeSessions(UID) {
    if (!UID) {
      throw new Error("Required data not provided for request.");
    }
    return await api.getResponseData({
      url: `api/upcomingsessions/${UID}/nrOfUsedFreeSessions`,
      method: "get",
      withCredentials: true,
    });
  },
};

export default CalendarAPI;
